export const lockrScanRoutes = Object.freeze({
	LockrScanLogin: '/lockrscan/login',
	LockrScanDashboard: '/lockrscan/dashboard',
	LockrScanAccount: '/lockrscan/account',
	LockrScanSuccessScreen: '/lockrscan/success',
	LockrMailPreview: '/lockrmail/preview'
})